import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LetDirective } from '@ngrx/component';
import { filter, map, Subject, withLatestFrom } from 'rxjs';

import { PrivaNotificationModule } from '@priva/components/notification';
import { PrivaLocalizationModule } from '@priva/localization';

import { Tile } from '../../../../components/tile-list/models';
import { TileListComponent } from '../../../../components/tile-list/tile-list.component';
import { Activity } from '../../models';
import { ActivityListStore } from './activity-list.store';

@Component({
    selector: 'app-activity-list',
    templateUrl: './activity-list.component.html',
    styleUrl: './activity-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ActivityListStore],
    imports: [LetDirective, PrivaLocalizationModule, PrivaNotificationModule, TileListComponent],
})
export class ActivityListComponent {
    private destroyRef = inject(DestroyRef);
    private tileClickedEvent$ = new Subject<Tile>();

    private activitySelectedEvent$ = this.tileClickedEvent$.pipe(
        withLatestFrom(this.componentStore.activities$),
        map(([selectedTile, activities]) =>
            activities.find((activity) => activity.number.toString() === selectedTile.id),
        ),
        filter((selectedActivity): selectedActivity is Activity => !!selectedActivity),
    );

    activities = input(undefined, {
        transform: (value: Activity[]) => {
            this.componentStore.updateActivities(value);
        },
    });

    activitySelected = output<Activity>();

    tiles$ = this.componentStore.tiles$;

    constructor(private componentStore: ActivityListStore) {
        this.activitySelectedEvent$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((selectedActivity) => this.activitySelected.emit(selectedActivity));
    }

    onTileClicked(tile: Tile) {
        this.tileClickedEvent$.next(tile);
    }
}
